import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Hero } from "./Hero";
import { Features } from "./Features";
import { Portfolio } from "./Portfolio";
import { SEO } from "../components/SEO";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { RefreshCw, ArrowRight } from "lucide-react";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Fit Print Bros",
  "description": "Professional custom screen printing, DTF printing, embroidery, stickers, signs, and banners. Smart artwork analysis, transparent pricing, and fast turnaround.",
  "url": "https://fitprintbros.com",
  "priceRange": "$$",
  "areaServed": "United States",
  "serviceType": ["Screen Printing", "DTF Printing", "Embroidery", "Custom Stickers", "Vinyl Banners", "Yard Signs", "Vehicle Wraps"],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Printing Services",
    "itemListElement": [
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Custom T-Shirt Printing", "description": "Screen printing and DTF printing on t-shirts, hoodies, polos, and more" }},
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Custom Embroidery", "description": "Premium stitched logos and designs on apparel. Free digitizing included." }},
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Custom Stickers", "description": "Kiss cut and die cut vinyl stickers in any shape. Full color, waterproof." }},
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Signs & Banners", "description": "Large format vinyl banners, yard signs, vehicle wraps, and more" }}
    ]
  }
};

const HomePage = () => {
  const navigate = useNavigate();
  const [recentDesign, setRecentDesign] = useState(null);

  useEffect(() => {
    try {
      const cart = JSON.parse(localStorage.getItem("cart") || "[]");
      if (cart.length > 0) {
        const last = cart[cart.length - 1];
        setRecentDesign({
          name: last.product_name || "Your custom order",
          qty: last.quantity,
          number: last.design_number || null,
          type: "cart",
        });
      }
    } catch {}
  }, []);

  return (
    <div>
      <SEO
        title="Custom Screen Printing, DTF, Embroidery & Stickers"
        description="Professional custom printing services — screen printing, DTF, embroidery, stickers, signs & banners. Smart artwork analysis, transparent pricing, fast turnaround. Get a free quote today."
        path="/"
        jsonLd={homeJsonLd}
      />
      {recentDesign && (
        <div className="bg-ink border-b-2 border-ink text-paper" data-testid="quick-reorder-banner">
          <div className="max-w-[1280px] mx-auto px-4 sm:px-6 py-2.5 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <RefreshCw className="w-4 h-4 text-acid" />
              <span className="font-mono text-[11px] uppercase tracking-[0.1em]">
                Welcome back — <strong className="text-acid">{recentDesign.name}</strong> ({recentDesign.qty} pcs) is ready.
              </span>
            </div>
            <div className="flex items-center gap-2">
              <Button
                size="sm"
                onClick={() => navigate("/cart")}
                className="bg-signal text-bone border-2 border-paper/20 font-mono text-[10px] uppercase tracking-wider font-bold h-7 hover:bg-acid hover:text-ink"
                data-testid="reorder-cart-btn"
              >
                View Cart <ArrowRight className="w-3 h-3 ml-1" />
              </Button>
              <Button
                size="sm"
                onClick={() => navigate("/my-designs")}
                variant="ghost"
                className="text-paper/60 hover:text-acid font-mono text-[10px] uppercase tracking-wider h-7"
                data-testid="reorder-designs-btn"
              >
                My Designs
              </Button>
            </div>
          </div>
        </div>
      )}
      <Hero />
      <Features />
      <Portfolio />
    </div>
  );
};

export { HomePage };
export default HomePage;
